// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HotkeysController from "./hotkeys_controller"
application.register("hotkeys", HotkeysController)

import IbanValidatorController from "./iban_validator_controller"
application.register("iban-validator", IbanValidatorController)

import LocationSelectorController from "./location_selector_controller"
application.register("location-selector", LocationSelectorController)

import MapController from "./map_controller"
application.register("map", MapController)

import MultiDownloaderController from "./multi_downloader_controller"
application.register("multi-downloader", MultiDownloaderController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import SearchableTableController from "./searchable_table_controller"
application.register("searchable-table", SearchableTableController)

import SpinnerController from "./spinner_controller"
application.register("spinner", SpinnerController)

import Stancer__SepaController from "./stancer/sepa_controller"
application.register("stancer--sepa", Stancer__SepaController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
